import React from 'react';

import { useToolkitDispatch } from '../../../../../../hooks';
import TaskLinkageForm from '../../../../../../features/TaskForm/components/TaskLinkageForm';
import { enterTasksPreviewMode } from '../../../../../../state/ui/planning/tasks';
import {
    useLinkageAction,
    useSelectedTaskId,
} from '../../../../../../state/ui/planning/tasks/index.hooks';

export const PlanningExternalLinkages = () => {
    const toolkitDispatch = useToolkitDispatch();
    const taskId = useSelectedTaskId();
    const handleCloseClick = () => {
        toolkitDispatch(enterTasksPreviewMode(taskId));
    };

    const action = useLinkageAction();
    return (
        <TaskLinkageForm action={action} handleCloseClick={handleCloseClick} />
    );
};
